<template>
  <div class="bigbox" v-loading="loading">
    <div class="form">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="年份:">
          <el-select clearable @change="handelchange" v-model="formInline.year" placeholder="请选择" size="small"
                     style="width: 80px; margin-right: 20px">
            <el-option v-for="item in yearoptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="省|直辖市:">
          <el-select clearable @change="handelchange" v-model="formInline.province" placeholder="不限" size="small"
                     style="width: 120px; margin-right: 20px" value-key="id">
            <el-option v-for="item in provinceList" :key="item.id" :label="item.name" :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="科别类型:">
          <el-select clearable @change="disciplineTypeChange" v-model="formInline.disciplineType" placeholder="不限"
                     size="small" style="width: 100px; margin-right: 20px">
            <el-option v-for="item in options1" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="录取批次：">
          <el-select clearable @change="batchChange" v-model="formInline.admitBatch" placeholder="不限" size="small"
                     style="width: 140px; margin-right: 20px">
            <el-option v-for="item in batchoptions" :key="item.batchId" :label="item.batch" :value="item.batch">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="关联院校:">
          <el-select clearable v-model="formInline.hasRelateGx" placeholder="不限" size="small"
                     style="width: 100px; margin-right: 20px">
            <el-option v-for="item in hasRelate" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="高校省份:">
          <el-select clearable v-model="formInline.collegeProvince" placeholder="不限" size="small"
                     style="width: 100px; margin-right: 20px" value-key="id">
            <el-option v-for="item in provinceList" :key="item.id" :label="item.name" :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="院校：">
          <el-input v-model="formInline.college" placeholder="请输入高校名称或代码" size="small"
                    style="width: 180px; margin-right: 20px" clearable></el-input>
        </el-form-item>
        <el-form-item label="专业组：">
          <el-input v-model="formInline.specialty" placeholder="请输入专业组名称或代码" size="small"
                    style="width: 190px; margin-right: 20px" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="splanpage">搜索</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="topright">
      <div style="padding-top: 4px">
        <span style="color: #666666; font-size: 14px; margin-right: 5px">显示更多信息</span>
        <el-switch
            v-model="showMore"
            active-color="#1ab394"
            inactive-color="#999999"
            style="margin-right: 10px"></el-switch>
      </div>
<!--      <el-button size="small" type="primary" v-permission="'901101'" @click="showSynchronousInclusionSpecialty()">同步包含专业-->
<!--      </el-button>-->
      <el-button size="small" type="danger" @click="delets" v-permission="'901102'">删除</el-button>
      <el-button type="primary" size="small" @click="cdkeyExport" v-permission="901100">导出</el-button>
      <el-upload class="upload1" action="/com/had-login/admission/admission-splan/importExcel" :headers="uploadheaders"
                 accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
                 :show-file-list="false" :on-progress="uploading" :on-success="importSuccess" v-permission="'901101'">
        <el-button type="primary" size="small">导入</el-button>
      </el-upload>
      <el-button type="primary" size="small" style="margin-left: 10px" v-permission="'901101'">
        <a :href="`${path}excel/yxzyzzsjh.xlsx`" download="专业组招生计划模板.xlsx" style="color: #fff">下载模板</a>
      </el-button>
    </div>
    <div class="table">
      <el-table :stripe="true" size="mini" :height="tableHeigth" :data="tableData" border style="width: 100%"
                :header-cell-style="{ 'text-align': 'center', 'font-size': '14px', 'padding': '0px' }"
                :cell-style="cellStyle"
                @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column label="院校名称" min-width="160">
          <template slot-scope="scope">
            <div class="maxlength">
              {{ scope.row.collegeName }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="collegeCode" label="院校代码" width="80">
        </el-table-column>
        <el-table-column label="关联院校" min-width="160">
          <template slot-scope="scope">
            <div class="maxlength">
              {{ scope.row.universityName }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="specialtyCode" label="专业组代码" width="100">
        </el-table-column>
        <el-table-column prop="specialtyOptions" label="专业组" min-width="140">
        </el-table-column>
        <el-table-column label="选考科目要求" width="150" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ matchRequiredType(scope.row.requiredType) }}</span>
            <span v-if="scope.row.requiredType !== 0">{{ scope.row.requiredDiscipline }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="specialtyName" label="包含专业" width="200" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{scope.row.specialtyName ? scope.row.specialtyName : '/'}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="year" label="年份" width="80"></el-table-column>
        <el-table-column prop="province" label="省|直辖市" width="120" show-overflow-tooltip></el-table-column>
        <el-table-column label="科别类型" width="100">
          <template slot-scope="scope">
            <div v-if="scope.row.disciplineType === 4">历史类</div>
            <div v-if="scope.row.disciplineType === 3">物理类</div>
            <div v-if="scope.row.disciplineType === 2">文科</div>
            <div v-if="scope.row.disciplineType === 1">理科</div>
            <div v-if="scope.row.disciplineType === 0">不分文理</div>
          </template>
        </el-table-column>
        <el-table-column prop="admitBatch" label="录取批次" width="150"></el-table-column>
        <el-table-column prop="planNum" label="招生人数" width="80"></el-table-column>
        <el-table-column prop="currentYearLowestScore" :label="currentYear + '年最低分'" width="80" v-if="showMore"></el-table-column>
        <el-table-column prop="currentYearLowestRanking" :label="currentYear + '年最低位次'" width="80" v-if="showMore"></el-table-column>
        <el-table-column prop="currentYearPlanNum" :label="currentYear + '年计划人数'" width="80" v-if="showMore"></el-table-column>
        <el-table-column prop="lastYearLowestScore" :label="(currentYear - 1) + '年最低分'" width="80" v-if="showMore"></el-table-column>
        <el-table-column prop="lastYearLowestRanking" :label="(currentYear - 1) + '年最低位次'" width="80" v-if="showMore"></el-table-column>
        <el-table-column prop="lastYearPlanNum" :label="(currentYear - 1) + '年计划人数'" width="80" v-if="showMore"></el-table-column>
        <el-table-column prop="beforeYearLowestScore" :label="(currentYear - 2) + '年最低分'" width="80" v-if="showMore"></el-table-column>
        <el-table-column prop="beforeYearLowestRanking" :label="(currentYear - 2) + '年最低位次'" width="80" v-if="showMore"></el-table-column>
        <el-table-column prop="beforeYearPlanNum" :label="(currentYear - 2) + '年计划人数'" width="80" v-if="showMore"></el-table-column>
        <el-table-column label="所在城市" width="100" v-if="showMore" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.collegeProvince">{{scope.row.collegeProvince}}</span>
            <span v-if="scope.row.collegeCity">{{scope.row.collegeCity}}</span>
          </template>
        </el-table-column>
        <el-table-column label="院校标签" width="100" v-if="showMore" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{scope.row.collegeTag ? scope.row.collegeTag : '/'}}</span>
          </template>
        </el-table-column>
        <el-table-column label="院校性质" width="80" v-if="showMore" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{scope.row.collegeCharacter ? scope.row.collegeCharacter : '/'}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="postgraduateAdmissionRate" label="保研率" width="80" v-if="showMore"></el-table-column>
        <el-table-column prop="masterSpecialtyNum" label="硕士专业数" width="100" v-if="showMore"></el-table-column>
        <el-table-column prop="doctorSpecialtyNum" label="博士专业数" width="100" v-if="showMore"></el-table-column>
        <el-table-column label="操作" width="80">
          <template slot-scope="scope" v-if="scope.row.admissionSplanId">
            <el-button type="text" @click="del(scope.row.admissionSplanId)" style="color: #f56c6c; font-size: 14px"
                       v-permission="'900902'">删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <div style="font-size: 14px; color: #333333; padding-left: 10px">
        当前为第{{ formInline.current }}页/ 总共{{ totalPages }}页，总记录数为{{
          total
        }}条
      </div>

      <el-pagination background @current-change="handleChange" :current-page.sync="formInline.current"
                     :page-size="formInline.size" layout="prev, pager, next" :total="total">
      </el-pagination>
    </div>
    <!-- 多数据操作 -->
    <el-dialog title="请选择操作数据操作" :visible.sync="centerDialogVisible" width="400px" center>
      <div class="centerdiv">
        <el-radio v-model="radio" :label="1">当前勾选数据</el-radio>
        <el-radio v-model="radio" :label="2">当前条件数据</el-radio>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="chooseset" size="small">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="同步包含专业" :visible.sync="includeDialogVisible" width="450px">
      <el-form  label-width="100px">
        <el-form-item label="年份:" >
          <el-select v-model="synchronousParams.year" placeholder="请选择" size="small"
                     style="width: 240px; margin-right: 20px">
            <el-option v-for="item in yearoptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="省份:">
          <el-select v-model="synchronousParams.provinceId" placeholder="不限" size="small"
                     style="width: 240px; margin-right: 20px" clearable @change="synchronousProvinceChange">
            <el-option v-for="item in provinceList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="includeDialogVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="synchronousInclusionSpecialty" size="small">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from "@/util/request";
import lpyMixin from "@/mixin/lpyMixin";
import {getProvinceList} from "@/api/index.js";
import {splandeleteBatch, splandeletes, splanpage,} from "@/api/collegeEntranceExamination.js";
import {getOneProvince, synchronousPlanInclusionSpecialty,} from "@/api/systemManagement.js";

export default {
  mixins: [lpyMixin],
  data() {
    return {
      includeDialogVisible: false,
      cellStyle: {
        "text-align": "center",
        "font-size": "14px",
        visibility: "hidden",
      },
      radio: 1,
      total: 0,
      totalPages: 1,
      hasRelate: [
        {label: "未关联", value: 0},
        {label: "已关联", value: 1},
      ],
      centerDialogVisible: false,
      uploadheaders: {
        sessionId: sessionStorage.getItem("sessionId") || "",
      },
      options1: [
        {label: "不分文理", value: 0},
        {label: "理科", value: 1},
        {label: "文科", value: 2},
        {label: "物理类", value: 3},
        {label: "历史类", value: 4},
      ], //科别
      path: process.env.BASE_URL,
      loading: false,
      batchoptions: [],
      disabled: true,
      formInline: {
        size: 500,
        current: 1,
        province: {id: "", name: ""},
        collegeProvince: {id: "", name: ""},
        isOptions: 1,
        disciplineType: null,
        admitBatch: "",
      },
      tableData: [],
      input: "",
      provinceList: [],
      dialogVisible: false,
      id: "",
      // provinceobj: {},
      yearoptions: [],
      ids: [],
      lastDisciplineType: 0,
      lastBatch: "",
      synchronousParams: {
        year: new Date().getFullYear(),
        provinceId: "",
        provinceName: "",
      },
      showMore: false,
      currentYear: new Date().getFullYear()
    };
  },
  mounted() {
    for (var i = 0; i < 500; i++) {
      this.tableData.push({});
    }
    // this.splanpage()
    this.getProvinceList();
    this.getyearsoptions();
  },
  methods: {
    matchRequiredType(requiredType) {
      switch (requiredType) {
        case 0:
          return "不提科目要求";
        case 1:
          return "任选一门报考：";
        case 2:
          return "均报考：";
      }
    },
    handleSelectionChange(val) {
      this.ids = [];
      val.forEach((item) => {
        if (item.admissionSplanId) {
          this.ids.push(item.admissionSplanId);
        }
      });
      if (val.length == this.ids.length && val.length > 0) {
        this.disabled = false;
      } else {
        this.disabled = true;
      }
    },
    showSynchronousInclusionSpecialty() {
      this.includeDialogVisible = true;
    },
    synchronousProvinceChange(val) {
      let provinceList = this.provinceList.filter(item => item.id === val)
      if (provinceList && provinceList.length > 0) {
        this.synchronousParams.provinceName = provinceList[0].name
      } else {
        this.synchronousParams.provinceName = ""
      }
    },
    synchronousInclusionSpecialty() {
      let message = "";
      if (this.synchronousParams.provinceId) {
        message = `确认同步${this.synchronousParams.provinceName}${this.synchronousParams.year}年的包含专业吗？`
      } else {
        message = `确认同步${this.synchronousParams.year}年的包含专业吗？`
      }

      this.$confirm(message, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.includeDialogVisible = false;
        this.$message({
          message: "正在后台同步数据，请耐心等待",
          type: "success",
        });
        synchronousPlanInclusionSpecialty(this.synchronousParams).then((res) => {
          if (res.code == 1) {
            this.$message({
              message: "同步成功",
              type: "success",
            });
          }
        });
      });
    },

    chooseset() {
      if (this.radio == 1) {
        if (this.ids.length == 0) {
          this.$message.error("当前无勾选数据");
        } else {
          this.$confirm(
              "确定要删除当前勾选的共" + this.ids.length + "条数据吗",
              "提示",
              {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              }
          )
              .then(() => {
                splandeleteBatch({idList: this.ids, type: 1}).then((res) => {
                  if (res.code == 1) {
                    this.splanpage();
                    this.$message({
                      message: "删除成功",
                      type: "success",
                    });
                    this.centerDialogVisible = false;
                  }
                });
              })
              .catch(() => {
              });
        }
      }
      if (this.radio == 2) {
        let deletePramas = {...this.formInline};
        deletePramas.type = 2;
        this.formInline.size = 1;
        splanpage(this.formInline).then((res) => {
          if (res.code == 1) {
            this.formInline.size = 500;
            let totalCount = res.data.total;
            this.$confirm(
                "确定要删除当前条件下共" + totalCount + "条数据吗",
                "提示",
                {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning",
                }
            )
                .then(() => {
                  splandeleteBatch(deletePramas).then((res) => {
                    if (res.code == 1) {
                      this.splanpage();
                      this.$message({
                        message: "删除成功",
                        type: "success",
                      });
                      this.centerDialogVisible = false;
                    }
                  });
                })
                .catch(() => {
                });
          }
        });
      }
    },
    //批量删除
    delets() {
      this.centerDialogVisible = true;
    },
    //获取录取批次
    handelchange() {
      this.formInline.disciplineType = null;
      this.formInline.admitBatch = null;
      this.batchoptions = [];
      if (this.formInline.year && this.formInline.province.id) {
        // getProvincePage({
        //   year: this.formInline.year,
        //   areaProvinceId: this.formInline.province.id,
        // }).then((res) => {
        //   console.log(res, "res");
        //   let data = res.data || {};
        //   let arr = data.records || [];
        //   this.batchoptions = arr[0].batchs || [];
        // });
        getOneProvince({
          year: this.formInline.year,
          areaProvinceId: this.formInline.province.id,
        }).then((res) => {
          if (res.code == 1) {
            let data = res.data;
            this.batchoptions = data.batchs || [];
            if (data.pattern == 3) {
              this.options1 = [
                {label: "理科", value: 1},
                {label: "文科", value: 2},
              ];
            }
            if (data.pattern == 2) {
              this.options1 = [
                {label: "物理类", value: 3},
                {label: "历史类", value: 4},
              ];
            }
            if (data.pattern == 1) {
              this.options1 = [{label: "不分文理", value: 0}];
            }
          }
          //判断上次科别类型和批次是否存在
          this.options1.forEach((item) => {
            if (item.value == this.lastDisciplineType) {
              this.formInline.disciplineType = item.value;
            }
          });

          this.batchoptions.forEach((item) => {
            if (item.batch == this.lastBatch) {
              this.formInline.admitBatch = item.batch;
            }
          });
        });
      } else {
        this.options1 = [
          {label: "不分文理", value: 0},
          {label: "理科", value: 1},
          {label: "文科", value: 2},
          {label: "物理类", value: 3},
          {label: "历史类", value: 4},
        ];
      }
    },
    disciplineTypeChange(value) {
      this.lastDisciplineType = value;
    },

    batchChange(value) {
      this.lastBatch = value;
    },
    // 跳页
    handleChange(page) {
      console.log(page);
      this.formInline.current = page;
      this.splanpage();
    },
    //获取列表
    splanpage() {
      this.formInline.province = this.formInline.province || {};
      if (!this.formInline.collegeProvince) {
        this.formInline.collegeProvince = null;
      }
      splanpage(this.formInline).then((res) => {
        if (res.code == 1) {
          this.cellStyle.visibility = "visible";
          console.log(res, "res");
          let data = res.data || {};
          this.tableData = data.records || [];
          if (this.tableData.length > 0 && this.tableData[0].currentYear) {
            this.currentYear = this.tableData[0].currentYear
          }
          this.total = data.total || 0;
          this.totalPages = data.pages;
        }
      });
    },
    uploading() {
      this.loading = true;
    },
    // 导出
    cdkeyExport() {
      let data = this.formInline;
      axios({
        method: "post",
        url: "/com/had-login/admission/admission-splan/exportExcel",
        data: data,
        responseType: "blob",
      })
          .then((res) => {
            const elink = document.createElement("a");
            elink.download = "院校专业组招生计划列表.xls"; //定义表格名称，后缀是文件格式
            elink.style.display = "none";
            const blob = new Blob([res], {
              type: "application/vnd.ms-excel",
            });
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click();
            document.body.removeChild(elink);
          })
          .catch((err) => {
            console.log(err);
          });
    },
    importSuccess(res) {
      this.loading = false;
      if (res.code === 1) {
        this.$message.success("导入成功")
      } else {
        this.open(res.msg);
      }
    },
    open(data) {
      this.$alert(data, "错误", {
        confirmButtonText: "确定",
        callback: (action) => {
        },
      });
    },
    //获取省份
    getProvinceList() {
      getProvinceList().then((res) => {
        this.provinceList = res.data;
      });
    },
    //获取年份
    getyearsoptions() {
      let date = new Date();
      let year = date.getFullYear();
      this.synchronousParams.year = year;
      this.formInline.year = year;
      this.formInline = {...this.formInline};
      for (let i = -2; i < 10; i++) {
        this.yearoptions.push({label: year - i, value: year - i});
      }
    },
    del(id) {
      this.id = id;
      this.$confirm("是否删除此条招生计划？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
          .then(() => {
            this.splandeletes();
          })
          .catch(() => {
          });
    },
    splandeletes() {
      splandeletes({admissionPlanIds: this.id}).then((res) => {
        if (res.code == 1) {
          this.splanpage();
        }
      });
    },
  }
  ,
}
;
</script>

<style lang="less" scoped>
.bigbox {
  padding: 20px 20px 0px;

  /deep/ .el-form-item {
    margin-bottom: 12px !important;
  }

  /deep/ .upload1 {
    display: inline-block;
    margin-left: 10px;
  }

  .topright {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 10px;
  }

  .table {
    position: relative;

    .mask {
      position: absolute;
      width: 100%;
      height: 563px;
      top: 37px;
      left: 0px;
      background-color: rgba(255, 255, 255, 1);
      z-index: 99999999;
    }
  }

  /deep/ .maxlength {
    display: -webkit-box !important;

    -webkit-box-orient: vertical !important;

    -webkit-line-clamp: 2 !important;
    overflow: hidden !important;
    font-size: 14px !important;
  }

  .button {
    position: absolute;
    top: -56px;
    right: 0px;
  }

  .pagination {
    display: flex;
    justify-content: space-between;
    padding-top: 10px;
  }
}
</style>
